<template lang="pug">
v-container(fluid pr-0 mr-0)
  template(v-if="listings.length > 0 || opportunities.length > 0 || (!loading && listings.length === 0 && opportunities.length === 0)")
    kubiqa-misc-empty-state(
      v-if="!loading && listings.length === 0 && opportunities.length === 0"
      :title="$t('Common.emptyStates.relatedTitle')"
      compact
      icon="mdi-link-variant-off"
    )
    template(v-else)
      v-row(no-gutters align="center" justify="space-between")
        v-col
          v-row(dense align="center")
            v-col(cols="auto")
              span(class="tw-font-bold") Related to
            v-col(class="mr-1")
              v-divider(v-if="!$vuetify.breakpoint.mobile")

        v-col(cols="auto")
          v-btn-toggle(dense v-model="toggle_exclusive")
            v-btn(
              v-if="listings.length > 0"
              text
              :ripple="false"
              @click="listings"
              color="blue-grey lighten-2"
              width="auto"
            )
              span(class="tw-font-medium") {{ $t('Common.listings') }}
            v-btn(
              v-if="opportunities.length > 0"
              text
              :ripple="false"
              @click="getOpportunities"
              color="blue-grey lighten-2"
              width="auto"
            )
              span(class="tw-font-medium") {{ $t('Common.opportunities') }}
      v-row(dense)
        v-col
          template(v-if="toggle_exclusive == 0 && listings.length > 0")
            template(v-for="(listing, index) in listings" :index="index")
              kubiqa-contacts-related-listing-item(:key="listing.id" :item="listing" :index="index")
          template(
            v-if="(toggle_exclusive == 1 && opportunities.length > 0) || (toggle_exclusive == 0 && listings.length == 0 && opportunities.length > 0)"
          )
            template(v-for="(opportunity, index) in opportunities" :index="index")
              kubiqa-contacts-related-opportunity-item(:key="opportunity.id" :item="opportunity" :index="index")
</template>
<script>
export default {
  props: {
    contact: {
      type: Number,
      default: null,

      required: true,
    },
  },
  data() {
    return {
      editDialog: false,
      toggle_exclusive: 0,
      listings: [],
      opportunities: [],
      loading: true,
    };
  },
  mounted() {
    Promise.all([this.getListings(), this.getOpportunities()]).then(() => {
      this.loading = false;
    });
  },
  methods: {
    getListings() {
      return this.$store.dispatch('contacts/getListings', this.contact).then((res) => {
        this.listings = res;
      });
    },
    getOpportunities() {
      return this.$store.dispatch('contacts/getOpportunities', this.contact).then((res) => {
        this.opportunities = res;
      });
    },
  },
};
</script>
